export default __webpack_public_path__ + "static/media/loading-primary.81865077.svg";